export const SET_PRICE_TRACKS = 'price-track/SET_PRICE_TRACKS';
export const SET_PRICE_TRACK = 'price-track/SET_PRICE_TRACK';
export const ADDING_PRICE_TRACK = 'price-track/ADD_PRICE_TRACK';